import styles from "./NewExpenseFormMessage.module.css";
const NewExpenseFormMessage = (props) => {
  const { isValid, message } = props;
  return (
    <>
      {!isValid && (
        <p id={styles["error"]}>
          {message.message}
        </p>
      )}
      {isValid && (
        <p id={styles["success"]}>
          {message.message}
        </p>
      )}
    </>
  );
};

export default NewExpenseFormMessage;
